import React from 'react';

import style from './ChoiceCard.module.scss';

export default function ChoiceCard({onClick, role, text, title, icon}) {
    return (
        <div className={style.cardWrapper} onClick={() => onClick(role)}>
            {icon}
            <div className={style.textWrapper}>
                <header className={style.cardTitle}>{title}</header>
                <main className={style.cardContent}>{text}</main>
            </div>
        </div>
    );
}
